module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Password</span></div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <input id=\"mainPasswordText\" type=\"text\" name=\"text\" value=\"")
    ; __append(escapeFn( text ))
    ; __append("\" maxlength=\"")
    ; __append(escapeFn( maxChars ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-90\">Max chars</label>\r\n        <div class=\"nopadding-r\">\r\n            <input type=\"text\" name=\"maxChars\" style=\"width:45px;\" value=\"")
    ; __append(escapeFn( maxChars ))
    ; __append("\" />\r\n        </div>\r\n    </div>  \r\n</div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-90\">Min chars</label>\r\n        <div class=\"nopadding-r\">\r\n            <input type=\"text\" name=\"minChars\" style=\"width:45px;\" value=\"")
    ; __append(escapeFn( minChars ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-90\">Required chars</label>\r\n        <div id=\"password_req_chars\" class=\"nopadding-r\">\r\n            <select id=\"passwordRequiredChars\" name=\"passwordRequiredChars\" >\r\n                <option value=\"weak\">None</option>\r\n                <option value=\"strong\">Alpha and numeric</option>\r\n                <option value=\"verystrong\">Alpha, numeric and special</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <div id=\"propTextTitle\" class=\"col-md-1 prop-sublabel nopadding-l\" style=\"width: 35px;\">Align</div>\r\n        <div id=\"propTextAlignment\" class=\"col-xs-10 nopadding\">\r\n            <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( alignLeftSelection ))
    ; __append("\" />\r\n            <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignCenterSelection ))
    ; __append("\" />\r\n            <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignRightSelection ))
    ; __append("\" />\r\n        </div>\r\n\r\n    </div>\r\n</div>")
  }
  return __output;

}